import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import * as React from 'react';
import { MyQuotationsDetailsRowItems } from '../../../models/quotations/MyQuotation';
import { formatPrice } from '../../../utils/numberFormatter';

export const MyQuotationProductsRow: React.FC<MyQuotationsDetailsRowItems> = (
    props
) => {
    const { row } = props;

    return (
        <>
            <TableRow hover>
                {/*<TableCell padding="checkbox"></TableCell>*/}
                <TableCell sx={{ width: '30%' }}>{row.description}</TableCell>
                <TableCell align="right">
                    {row.quantity} {row.unitOfMeasureCode}
                </TableCell>
                <TableCell sx={{ width: '14%' }} align="right">
                    {formatPrice(row.netUnitPrice)} Ft
                </TableCell>
                <TableCell sx={{ width: '14%' }} align="right">
                    {formatPrice(row.netLineAmount)} Ft
                </TableCell>
                <TableCell sx={{ width: '14%' }} align="right">
                    27%
                </TableCell>
                <TableCell sx={{ width: '14%' }} align="right">
                    {formatPrice(row.netLineAmount * 1.27)} Ft
                </TableCell>
            </TableRow>
        </>
    );
};
